var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcons02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 73.6672C58.1461 73.6672 73.6671 58.1462 73.6671 39.0001C73.6671 19.854 58.1461 4.33301 39 4.33301C19.8539 4.33301 4.33289 19.854 4.33289 39.0001C4.33289 58.1462 19.8539 73.6672 39 73.6672Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 16.4424C29.6205 16.4424 21.9895 24.0734 21.9895 33.4529C22.0454 42.6751 32.3544 53.9851 39 61.5576C45.6469 53.9825 55.9533 42.6777 56.0105 33.4529C56.0105 24.0734 48.3795 16.4424 39 16.4424ZM39 44.3768C33.254 44.3768 28.5688 39.6903 28.5688 33.9456C29.1005 20.1305 48.8982 20.1279 49.4325 33.9456C49.4325 39.6916 44.746 44.3768 39.0013 44.3768H39Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcons02);
export default __webpack_public_path__ + "static/media/contact_icons-02.bc8c42a851be53ef0d0ed6950d90c41f.svg";
export { ForwardRef as ReactComponent };